// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"_3RjGkXG2unGLvwo57gLgnh"};